var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ margin: _vm.margin, boxShadow: _vm.boxShadow, backgroundColor: _vm.bgColor, borderRadius: '4px' })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }